<template>
    <div class="w-full flex flex-col min-h-[300px] box-border">
        <div class="w-full h-14 rounded-t-lg bg-background-3 border border-interactive-11 flex px-4 box-border text-center items-center justify-center">
            <span>Payment completed</span>
        </div>
        <div class="w-full flex flex-1 text-center flex-col items-center justify-center">
            <p class="text-xl">Thank you for your ${{amountToBeDonated}} gift, {{ firstName }}!</p>
            <p class="text-sm text-gray-600 mt-1">You just changed the world for the better.</p>
        </div>
        <div class="w-full px-4 box-border">
            <Button label="Donate again" class="w-full mt-4" @click="resetStore"/>
        </div>
    </div>
</template>

<script setup>
import {computed} from "vue";
import Button from "@/components/Button.vue";
import {useDonationStore} from "@/store/useDonationStore";
import {storeToRefs} from "pinia";

const {resetStore} = useDonationStore();
const {amountToBeDonated, billingInfo} = storeToRefs(useDonationStore());

const firstName = computed(() => {
    if(!billingInfo.value) {
        return 'donor'
    }
    return billingInfo.value.first_name;
})
</script>